<template>
  <div>
    <ejs-treegrid ref='dvlGrid' :dataSource='dataSource' childMapping="children"
                  autoCheckHierarchy="true" collapsed="true"
                  :rowDataBound="rowDataBound" height='calc(100vh - 236px)'
                  :allowResizing='true'>
      <e-columns>
        <e-column field='netCode' :headerText='$t("Software.td_neID")' width='12%' :showCheckbox="true"
                  clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='netType' :headerText='$t("Software.td_neName")' width='8%'
                  clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='taskId' :headerText='$t("Software.td_taskId")' width='8%'
                  clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='taskType' :headerText='$t("Software.td_taskType")' width='8%'
                  :valueAccessor='taskTypeFormatter' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='operType' :headerText='$t("Software.td_operationType")' width='8%'
                  :valueAccessor='operTypeFormatter' clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='status' :headerText='$t("Software.td_status")' width='7%' :valueAccessor='statusFormatter'
                  clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='result' :headerText='$t("Software.td_result")' width='7%' :valueAccessor='resultFormatter'
                  clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='createTime' :headerText='$t("Software.td_createTime")' width='9%'
                  clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='scheduledtime' :headerText='$t("Software.td_executionTime")' width='9%'
                  clipMode='EllipsisWithTooltip'></e-column>
        <e-column field='detail' :headerText='$t("Software.td_detail")' width='14%'
                  clipMode='EllipsisWithTooltip'></e-column>
        <!--<e-column field='taskId' :isPrimaryKey='true' :visible='false'></e-column>-->
      </e-columns>
    </ejs-treegrid>
    <ejs-pager ref='pager' @click='query' :currentPage='pageInfo.pageNo' :pageSize='pageInfo.pageSize'
               :totalRecordsCount='pageInfo.totalCount' :pageCount='pageInfo.pageCount'></ejs-pager>
  </div>
</template>

<script>
  export default {
    name: 'DeviceVersionLog',
    data() {
      return {
        dataSource: [],
        pageInfo: {
          pageNo: 1,
          pageSize: 15,
          totalCount: 0,
          pageCount: 4
        },
        param: {
          upOrBack: 0,
          name: ''
        },
        taskmap: new Map().set(0, this.$t('Software.netask')).set(1, this.$t('Software.opetask')),
        opermap: new Map(
          [
            [0, this.$t('Software.download')],
            [1, this.$t('Software.active')],
            [2, this.$t('Software.DlandAt')],
            [3, this.$t('Software.rollback')],
            [4, this.$t('Software.upload')],
            [5, this.$t('Software.DlandUl')],
            [6, this.$t('Software.AtandUl')],
            [7, this.$t('Software.DlandAtandUl')],
            [8, this.$t('Software.RbandUl')]
          ]),
        statusmap: new Map(
          [
            [0, this.$t('Software.notstart')],
            [1, this.$t('Software.waitforexe')],
            [2, this.$t('Software.progressing')],
            [3, this.$t('Software.done')],
          ]),
        resultmap: new Map(
          [
            [0, this.$t('Software.success')],
            [1, this.$t('Software.fail')],
            [2, this.$t('Software.partSucc')],
          ]),
      }
    },
    methods: {
      init(param) {
        this.param = param;
        this.query();
      },
      query() {
        const searchMo = {
          taskType: this.param['upOrBack'],
          neIdOrName: this.param['name']
        };
        const url = `/lte/ems/packageManager/logDetail?pageNo=${this.pageInfo['pageNo']}&pageSize=${this.pageInfo['pageSize']}`;
        this.$axios.post(url, searchMo).then(response => {
          const data = response.data;
          const result = data.result;
          this.pageInfo['totalCount'] = data.totalCount;
          this.pageInfo['pageNo'] = data.pageNo;
          this.pageInfo['pageSize'] = data.pageSize;
          this.dataBinding(result);
        });
      },
      dataBinding(dataSource) {
        let resData = [];
        dataSource.forEach(element => {
          let re = {};
          re.parentId = element._parentId
          re.taskId = element.taskId;
          re.netCode = element.netCode;
          re.netType = element.netType;
          re.taskType = element.taskType;
          re.operType = element.operType;
          re.status = element.status;
          re.result = element.result;
          re.createTime = element.createTime;
          re.scheduledtime = element.scheduledtime;
          re.detail = element.detail;
          re.neId = element.neId;
          if (re.parentId == null) {
            re.children = [];
            resData.push(re);
          }
          else {
            resData.forEach(item => {
              if (item.taskId == re.parentId) {
                console.log(re);
                item.children.push(re);
              }
            });
          }
        });
        this.dataSource = resData;
      },
      rowDataBound(args) {
        // 只允许整包删除适配包，treegrid 子args.data['level'] = 1
        if (args.data['level'] === 1) {
          args.row.getElementsByClassName('e-checkbox-wrapper')[0].classList.add('h-system-disablecheckbox')
        }
      },
      taskTypeFormatter(field, data, column) {
        return this.taskmap.get(data['taskType']);
      },
      operTypeFormatter(field, data, column) {
        return this.opermap.get(data['operType']);
      },
      statusFormatter(field, data, column) {
        if (data['_parentId'] != undefined) {
          //根据子节点的状态还设置父节点的状态
          this.data.forEach(item => {
            if (item.taskId === data['taskId']) {
              if (data['status'] > 2 && item.status < 2) {
                item.status = 2;
              }
            }
          })
        }
        return this.statusmap.get(data['status']);
      },
      resultFormatter(field, data, column) {
        return this.resultmap.get(data['result']);
      },
    }
  }
</script>
